import { getTrackingStrings } from 'constants/trackingStrings';

const { closeAddStockLotDialog, cancelAddStockLot, saveAddStockLot } =
  getTrackingStrings();

export const getCopy = () => ({
  closeAddStockLotDialog,
  cancelAddStockLot,
  saveAddStockLot,
});
